<template>
  <nav role="list" :is="tag" :class="[baseCss, clickable ? 'bcq-list-clickable' : null, divider ? 'bcq-list-divider' : null]">
    <table-layout y-align="middle" equal-cells>
      <slot />
    </table-layout>
  </nav>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'List',
  mixins: [
    methods
  ],
  props: {
    tag: {
      type: String,
      default: 'nav'
    },
    divider: {
      type: Boolean,
      default: true
    },
    clickable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      baseCss: this.componentBaseCss('list', ['select-none'])
    }
  }
}
</script>
<style>
.bcq-list a.bcq-list-item:hover,
.bcq-list .bcq-list-item-selected,
.bcq-list .bcq-list-item.router-link-active,
.bcq-list.bcq-list-clickable .bcq-list-item:hover
{
  background: var(--router-link-active);
}

.bcq-ui-theme-dark .bcq-list a.bcq-list-item:hover,
.bcq-ui-theme-dark .bcq-list .bcq-list-item-selected,
.bcq-ui-theme-dark .bcq-list .bcq-list-item.router-link-active,
.bcq-ui-theme-dark .bcq-list.bcq-list-clickable .bcq-list-item:hover
{
  background: var(--router-link-active-dark);
}

.bcq-list.bcq-list-clickable .bcq-list-item
{
  cursor: var(--pointer-cursor);
}

.bcq-list.bcq-list-divider .bcq-table-layout-row:not(:last-child)
{
  border-bottom: solid 1px rgba(229, 231, 235, var(--tw-border-opacity));
}

.bcq-list .bcq-table-layout-cell
{
  height: 44px;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/list/list.vue